// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__L4Ess"};